import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/service',
        name: 'Service',
        component: () => import('../views/ServiceView.vue')
    },
    // 新增：AI产品路由
    {
        path: '/aiproduct',
        name: 'Aiproduct',
        component: () => import('../views/AiproductView.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/ContactView.vue')
    }
]

const router = new VueRouter({
    mode: 'history', // 去掉URL中的#，部署时需配置服务器重定向
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 } // 路由切换时回到顶部
    }
})

export default router